const _ = require("lodash");
const nseSymbolConfigs = require("./lib/constants/markets/in/nse/symbolConfigs.json");
const bseSymbolConfigs = require("./lib/constants/markets/in/bse/symbolConfigs.json");
const nyseSymbolConfigs = require("./lib/constants/markets/us/nyse/symbolConfigs.json");
const marketUtility = require("./lib/utility/market");

const IN = {
  ...require("./lib/constants/markets/in/configuration.json"),
  holidayDates: require("./lib/constants/markets/in/holidayDates.json"),
  weekendWorkingDates: require("./lib/constants/markets/in/weekendWorkingDates.json"),
  configs: [...nseSymbolConfigs, ...bseSymbolConfigs],
};

const US = {
  ...require("./lib/constants/markets/us/configuration.json"),
  holidayDates: require("./lib/constants/markets/us/holidayDates.json"),
  weekendWorkingDates: require("./lib/constants/markets/us/weekendWorkingDates.json"),
  configs: nyseSymbolConfigs,
};

const markets = {
  IN: { ...IN, utility: marketUtility(IN) },
  US: { ...US, utility: marketUtility(US) },
};

// Have to preload files for the first time

// _.chain(markets)
//   .keys()
//   .map((market) => markets[market].configs)
//   .flattenDeep()
//   .reduce((acc, config) => {
//     const { expiry } = config;
//     const { weekly, monthly } = expiry;

//     if (weekly && !acc[weekly]) {
//       acc[weekly] = weekly;
//     }
//     if (monthly && !acc[monthly]) {
//       acc[`${monthly}`] = monthly;
//     }

//     return acc;
//   }, {})
//   .value();

module.exports = { markets };
